import React from 'react';
import Button from './button';

const Popup = ({
  open,
  closePopup = () => {},
  confirmationPopup: {
    heading,
    subHeading,
    cancelButtonText,
    cancelButtonCallback,
    confirmButtonText,
    confirmButtonCallback,
  },
  children,
}) => {
  if (!open) return null;

  if (confirmButtonText) {
    return (
      <div className="fixed top-0 left-0 w-full h-full bg-white/10 backdrop-blur-sm flex items-center justify-center z-50 px-4">
        <div className="absolute top-0 left-0 w-full h-full z-10" onClick={closePopup} />
        <div className="bg-white rounded-lg py-10 px-6 max-w-xl flex flex-col gap-4 w-full relative z-20">
          <h2
            className="text-2xl font-normal text-center text-blue-10"
            dangerouslySetInnerHTML={{ __html: heading }}
          />
          <p
            className="text-sm text-gray-10 text-center"
            dangerouslySetInnerHTML={{ __html: subHeading }}
          />
          <div className="grid grid-cols-2 gap-4">
            <Button
              type="button"
              text={cancelButtonText}
              className={'bg-transparent border-2 border-blue-10 !text-blue-10 rounded-md'}
              callback={cancelButtonCallback}
            />
            <Button
              type="button"
              text={confirmButtonText}
              className={'bg-blue-10 !text-white rounded-md'}
              callback={confirmButtonCallback}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white/10 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="absolute top-0 left-0 w-full h-full z-10" onClick={closePopup} />
      <div className="bg-white rounded-lg p-4 max-w-2xl relative z-20">{children}</div>
    </div>
  );
};

export default Popup;
